import { useState } from "react";
import { Modal } from "../../components/common/Modal";
import DashboardChatHandler from "../../components/Dashboard/DashboardChatHandler";

const ChatModal = () => {
  const [selectedChatClient, setSelectedChatClient] = useState(null);

  const chatClientSelected = yes => {
    setSelectedChatClient(yes);
  };

  return (
    <Modal>
      <DashboardChatHandler
        isChatOpen={selectedChatClient}
        chatClientSelected={chatClientSelected}
      />
    </Modal>
  );
};

export default ChatModal;
